import { render } from "./today.vue?vue&type=template&id=68d52e36&ts=true"
import script from "./today.vue?vue&type=script&lang=ts"
export * from "./today.vue?vue&type=script&lang=ts"

import "./today.vue?vue&type=style&index=0&id=68d52e36&lang=less"

import exportComponent from "E:\\lcz\\WX.My\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__